
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"selectDate.button":"Select a date","time.hours.label":"Hour","time.minutes.label":"Minute","time.seconds.label":"Second","prev":"Previous","next":"Next"},"de":{"selectDate.button":"Wählen Sie ein Datum aus","time.hours.label":"Stunde","time.minutes.label":"Minute","time.seconds.label":"Sekunde","prev":"Vorherige","next":"Weiter"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();